export const MIN_AMOUNT_TO_WITHDRAW = 0;

// MIN_AMOUNT_TO_CREATE temporarily reduced.
// export const MIN_AMOUNT_TO_CREATE = 10_000;
export const MIN_AMOUNT_TO_CREATE = 5;
// export const MIN_AMOUNT_TO_CREATE = 20_000;
export const CUSTODY_FEE = "0.4%";
